import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dataAgentSessionService } from '../services/dataAgentSessionService';

export const getSessions = createAsyncThunk(
  'dataAgentSession/getSessions',
  async (options, { rejectWithValue }) => {
    try {
      const response = await dataAgentSessionService.getSessionsREST(options);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSessionById = createAsyncThunk(
  'dataAgentSession/getSessionById',
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await dataAgentSessionService.getSessionByIdREST(sessionId);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const dataAgentSessionSlice = createSlice({
  name: 'dataAgentSession',
  initialState: {
    sessions: [],
    session: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSessions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSessions.fulfilled, (state, action) => {
        state.loading = false;
        state.sessions = action.payload;
      })
      .addCase(getSessions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSessionById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSessionById.fulfilled, (state, action) => {
        state.loading = false;
        state.session = action.payload;
      })
      .addCase(getSessionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = dataAgentSessionSlice.actions;

export default dataAgentSessionSlice.reducer;
